'use client';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog';
import { logo } from '@/images';
import { setLoginPopup } from '@/redux/actions/common.action';
import { AppDispatch, RootState } from '@/redux/store';
import Image from 'next/image';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StepMobile, StepOtp, StepUser } from './components';

const steps: any = {
  1: StepMobile,
  2: StepOtp,
  3: StepUser,
};

interface TProps {
  isCuriobit?: boolean;
  onSuccess?: () => void;
}

export default function LoginDialog({ isCuriobit = false, onSuccess }: TProps): React.ReactNode {
  const initialState = {
    phone: '',
    countryPhoneCode: '+91',
    otpId: '',
    role: 'C',
  };

  const dispatch = useDispatch<AppDispatch>();

  const isLoginDialogOpen = useSelector(
    (state: RootState) => state.common.isLoginPopupOpen,
  );

  const [state, setState] = React.useState({ ...initialState });
  const updateState = (data: any) =>
    setState((state) => ({ ...state, ...data }));

  const [step, setStep] = React.useState(1);
  const Step = steps[step];

  const onNext = (specificStep?: number) => {
    return specificStep ? setStep(specificStep) : setStep(step + 1);
  };
  const onOpenChange = () => {   
    setStep(1);
    dispatch(setLoginPopup(false));
  };

  return (
    <Dialog open={isLoginDialogOpen} onOpenChange={onOpenChange}>
      <DialogContent className='h-fit w-full max-w-full max-h-fit rounded-t-2xl p-0 md:max-w-sm [&>button:last-child]:text-white'>
        <DialogHeader className='text-center'>
          <DialogTitle className='flex h-[150px] w-full flex-col items-center justify-center rounded-t-lg border-b bg-gradient-to-r px-6 py-6 text-3xl text-white'>
            <Image
              src={isCuriobit ? "/curiobit/logo-light.png" : logo.src}
              height={150}
              width={200}
              alt='greet fydo logo'
              aria-label='greet fydo logo'
              priority
              layout='intrinsic'
              loader={(options) => options?.src}
            />
            {isCuriobit &&
              <p className="w-[100%] font-montserrat text-sm font-normal leading-6 tracking-wide text-black text-center">
                A bit of curiosity
              </p>
            }
          </DialogTitle>
        </DialogHeader>
        <Step onNext={onNext} state={state} updateState={updateState} isCuriobit={isCuriobit} onSuccess={onSuccess} />
      </DialogContent>
    </Dialog>
  );
}
